var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFreeChargeIcon = function SvgFreeChargeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5903",
    "data-name": "Grupo 5903",
    transform: "translate(-606 -729)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1992",
    "data-name": "Ret\\xE2ngulo 1992",
    width: 30,
    height: 30,
    transform: "translate(606 729)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5898",
    "data-name": "Grupo 5898",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_18",
    "data-name": "Subtra\\xE7\\xE3o 18",
    d: "M22574.748,20589.5a12.749,12.749,0,1,1,6.258-23.85,3.479,3.479,0,0,0,1.021,2.33l.021.023-.021.018-.012.016a3.5,3.5,0,0,0,0,4.932l.021.023a3.5,3.5,0,0,0,4.9.023,12.588,12.588,0,0,1,.561,3.734A12.764,12.764,0,0,1,22574.748,20589.5Zm-3.775-10.568a1.085,1.085,0,0,0-.238.029.978.978,0,0,0-.715,1.191,4.5,4.5,0,0,0,3.742,3.279v.768a.986.986,0,0,0,1.973,0v-.748a4.864,4.864,0,0,0,2.986-1.49,3.253,3.253,0,0,0,.76-2.574c-.361-2.957-3.52-3.479-4.557-3.65h-.006c-2.5-.408-2.549-1.416-2.566-1.8a1.6,1.6,0,0,1,.516-1.289,2.524,2.524,0,0,1,1.205-.609,3.218,3.218,0,0,1,.723-.084,2.583,2.583,0,0,1,2.5,1.6.986.986,0,1,0,1.82-.76,4.457,4.457,0,0,0-3.385-2.719v-.768a.986.986,0,0,0-1.973,0v.777a.722.722,0,0,0-.105.021l-.02.006a3.86,3.86,0,0,0-3.254,3.918c.061,1.359.844,3.094,4.217,3.65,2.432.4,2.836,1.246,2.92,1.939a1.25,1.25,0,0,1-.289,1.043,3.339,3.339,0,0,1-2.357.879c-.031,0-.062,0-.094,0a3.569,3.569,0,0,1-1.715-.416,2.23,2.23,0,0,1-1.135-1.457A.986.986,0,0,0,22570.973,20578.928Z",
    transform: "translate(-21956 -19832.998)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_13",
    "data-name": "Uni\\xE3o 13",
    d: "M44502.434,40404.566l-1.434-1.437-1.437,1.438a1.514,1.514,0,0,1-2.121,0,1.521,1.521,0,0,1,0-2.133l1.434-1.434-1.434-1.437a1.5,1.5,0,0,1,2.121-2.121l1.438,1.434,1.434-1.434a1.5,1.5,0,0,1,2.133,2.121l-1.434,1.438,1.434,1.434a1.508,1.508,0,0,1-2.133,2.133Z",
    transform: "translate(-43870 -39666)",
    fill: "#c1c1c1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFreeChargeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/free-charge-icon.a804a2ed.svg";
export { ForwardRef as ReactComponent };